import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['zipCode', 'calculateButton', 'buttonLabel', 'spinner']
  static values = {
    variantId: String,
    savedZip: String
  }

  connect() {
    this.isCalculating = false
    
    if (this.savedZipValue && this.savedZipValue.length > 0) {
      // Delay to ensure input-mask has initialized and prevent duplicate calls
      setTimeout(() => {
        if (!this.isCalculating) {
          this.calculateShipping()
        }
      }, 200)
    }
  }

  handleZipCodeInput(event) {
    const value = event.target.value.replace(/\D/g, '')

    if (value.length === 8 && !this.isCalculating) {
      this.calculateShipping()
    }
  }

  calculateShipping() {
    if (this.isCalculating) {
      return
    }

    const zipCode = this.zipCodeTarget.value.replace(/\D/g, '')

    if (zipCode.length !== 8) {
      alert('Por favor, digite um CEP válido com 8 dígitos')
      return
    }

    if (!this.variantIdValue) {
      alert('Erro ao calcular frete. Por favor, recarregue a página.')
      return
    }

    this.isCalculating = true

    if (this.hasCalculateButtonTarget) {
      this.calculateButtonTarget.disabled = true
      this.calculateButtonTarget.setAttribute('aria-disabled', 'true')
      this.calculateButtonTarget.classList.add('opacity-50', 'cursor-not-allowed')
    }

    if (this.hasButtonLabelTarget) {
      this.buttonLabelTarget.classList.add('hidden')
    }

    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.remove('hidden')
    }

    fetch(`/products/${this.variantIdValue}/shipping_rates`, {
      method: 'POST',
      headers: {
        'Accept': 'text/vnd.turbo-stream.html',
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      },
      body: JSON.stringify({ 
        shipping_rate: { 
          zip_code: zipCode 
        } 
      })
    }).then(async response => {
      if (response.ok) {
        const html = await response.text()
        Turbo.renderStreamMessage(html)
      } else {
        console.error('Erro ao calcular as taxas de envio')
      }
    }).catch(error => {
      console.error('Houve um problema ao tentar calcular as taxas de envio', error)
    }).finally(() => {
      setTimeout(() => {
        this.isCalculating = false

        if (this.hasCalculateButtonTarget) {
          this.calculateButtonTarget.disabled = false
          this.calculateButtonTarget.setAttribute('aria-disabled', 'false')
          this.calculateButtonTarget.classList.remove('opacity-50', 'cursor-not-allowed')
        }

        if (this.hasButtonLabelTarget) {
          this.buttonLabelTarget.classList.remove('hidden')
        }

        if (this.hasSpinnerTarget) {
          this.spinnerTarget.classList.add('hidden')
        }
      }, 1000)
    })
  }
}
